<template>
  <div class="content_div" :style="{...stylek}">
    <el-input v-model="value" :placeholder="placeholder" @input="inputChange" @focus="focus" @blur="blur" />
    <div v-if="isLoad || list" class="list">
      <span v-if="isLoad || (list && list.length==0)" class="tanPopup">{{ isLoad ? '加载中...' : '暂无数据' }}</span>
      <ul v-if="!isLoad && list" class="ul">
        <li v-for="item in list" :key="item.id" class="ul_li" @click="change(item)">{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      default: 300
    },
    placeholder: {

    },
    stylek: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      value: '',
      list: null,
      isLoad: false
    }
  },
  methods: {
    debounce(func, wait) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        func()
      }, wait)
    },

    inputChange() {
      this.isLoad = true
      this.list = null
      this.debounce(() => {
        this.$emit('input', {
          value: this.value,
          cb: (list) => {
            this.list = list
            this.isLoad = false
          }
        })
      }, this.time)
    },

    focus() {
      this.inputChange()
    },

    blur() {
      setTimeout(() => {
        this.$emit('blur', () => {
          this.list = null
          this.isLoad = false
        })
      }, 200)
    },

    change(item) {
      this.$emit('change', item)
      this.value = item.name
      this.list = null
      this.isLoad = false
    }
  }
}
</script>

<style scoped lang="less">
 .content_div{
          width: 100%;
          position: relative;
          margin: 0px 10px;

          .list{
          border: 1px solid #ccc;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          border-top: none;
          position: relative;
          top: -2px;
          max-height: 304px;
          overflow: auto;

          .ul{
            .ul_li{
                padding: 11px;
                border-bottom: 1px solid #ccc;
                cursor: pointer;
                &:hover{
                  background-color: #f7f6f6;
                }
                &:last-child{
                  border-bottom: none;
                }
            }
          }
            .tanPopup{
            position: relative;
            display: inline-block;
            left: 50%;
            transform: translateX(-50%);
            padding: 20px 0px;
          }
          }

        }
</style>
